import { render } from "./ListNotIntegrated.vue?vue&type=template&id=2a741506&scoped=true"
import script from "./ListNotIntegrated.vue?vue&type=script&lang=js"
export * from "./ListNotIntegrated.vue?vue&type=script&lang=js"

import "./ListNotIntegrated.vue?vue&type=style&index=0&id=2a741506&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a741506"]])

export default __exports__